/* =================================================================
   br-header — sticky state, and closing the compact menu.

   Watches a zero-size sentinel inserted directly above the header.
   While the sentinel is visible the page is at rest; once it scrolls
   out, the sticky bar is engaged and data-sticky goes on .br-header so
   CSS can crossfade the lockup to the mark and pill the bar. An
   IntersectionObserver, not a scroll handler — no per-frame work.
   ================================================================= */

const header = document.querySelector('.br-header');

if (header) {
  const sentinel = document.createElement('div');
  sentinel.setAttribute('aria-hidden', 'true');
  sentinel.style.blockSize = '0';
  header.before(sentinel);

  const observer = new IntersectionObserver(([entry]) =>
    header.toggleAttribute('data-sticky', !entry.isIntersecting)
  );
  observer.observe(sentinel);
}

/* ── Compact menu: Escape and focus-leave close it (A11Y-A-15) ─────────
   The ≤900px menu is a native <details>. Natively it stays open on Escape
   and after focus has moved on, leaving a sheet over the page behind the
   keyboard user. Two additions, no focus trap:

   - Escape closes it and returns focus to the <summary> that opened it.
     Only when focus is inside the menu or nowhere (<body>) — while a modal
     dialog such as the cart drawer is open, focus is inside that dialog and
     Escape belongs to it.
   - Focus moving to an element outside the menu closes it. A null
     relatedTarget (the window lost focus, or a tap on something that takes
     none) is ignored, so switching apps does not collapse the menu.

   Delegated from document and resolved at event time, so the handlers bind
   once per page (a module runs once) and keep working when the theme editor
   re-renders the header section — there is nothing to unbind. Above 900px
   the <details> is display:none and can be neither open nor focused, so
   desktop behaviour is unchanged. */
const MENU_SELECTOR = '.br-header__mobile';

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape' || event.defaultPrevented) return;

  const menu = document.querySelector(`${MENU_SELECTOR}[open]`);
  if (!menu) return;

  const active = document.activeElement;
  if (active && active !== document.body && !menu.contains(active)) return;

  menu.open = false;
  menu.querySelector('summary')?.focus();
});

document.addEventListener('focusout', (event) => {
  if (!(event.target instanceof Element)) return;

  const menu = event.target.closest(`${MENU_SELECTOR}[open]`);
  const next = event.relatedTarget;
  if (!menu || !(next instanceof Node) || menu.contains(next)) return;

  menu.open = false;
});
